import { QuestionnaireCategoryGroupsDocument } from '@/api/queries';
import graphApi from '@/api';

export type CategoryGroupLink = {
  questionnaireCategoryId: string;
  groupId: string;
  groupName: string;
  groupActive: number;
};

const [, runSearchCategoryGroups] = graphApi(QuestionnaireCategoryGroupsDocument);

export const searchCategoryGroups = async (categoryIds: string[]): Promise<CategoryGroupLink[]> => {
  if (!categoryIds?.length) return [];
  const res = await runSearchCategoryGroups({ input: { questionnaireCategoryIds: categoryIds } });
  return (res?.questionnaireCategoryGroups || []).flatMap(({ questionnaireCategoryId, groups }) =>
    groups.map(({ groupId, name, active }) => ({ questionnaireCategoryId, groupId, groupName: name, groupActive: active }))
  );
};

export default searchCategoryGroups;
